<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Últimas visualizações"
            description="Profissionais que acessaram o sistema"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-12">
          <div class="form-group input-group">
            <select
              class="form-control"
              @change="onChangeFuncao($event)"
              v-model="funcao"
              name="funcao"
              required
            >
              <option value="" disabled>PERFIL</option>
              <option value="todos">TODOS</option>
              <option value="Gerente/Coordenador(a)">
                Gerente/Coordenador(a)
              </option>
              <option value="Secretário(a)">Secretário(a)</option>
              <option value="Administrador e-SUS PEC">
                Administrador e-SUS PEC
              </option>
              <option value="Agente Comunitário de Saúde">
                Agente Comunitário de Saúde
              </option>
              <option value="Aux/Téc Enfermagem">Aux/Téc Enfermagem</option>
              <option value="Enfermeiro(a)">Enfermeiro(a)</option>
              <option value="Médico(a)">Médico(a)</option>
              <option value="Odontólogo(a)">Odontólogo(a)</option>
              <option value="Recepcionista">Recepcionista</option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <div class="subtitle">
                <div class="subtitle-item">
                  <input
                    type="checkbox"
                    name=""
                    v-model="reds"
                    @change="onChangeReds($event)"
                  />
                  <span style="background-color: red"></span> Último acesso há
                  mais de 30 dias.
                </div>
              </div>
            </div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedUsuarios"
                :fields="dataFields"
                name="ultimas-visualizacoes"
              >
              </download-files>
            </div>
          </div>
          <tabela-cadastros
            :cadastros="displayedUsuarios"
            :loading="loading"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import TabelaCadastros from './TabelaCadastros'
import { mapState } from 'vuex'
import utils from '@/mixins/utils.js'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'

export default {
  name: 'UltimasVisualizacoes',
  metaInfo: {
    title: 'Últimas visualizações',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedUsuarios() {
      if (this.funcao != '') {
        let filter = this.usuarios.filter((item) => {
          if (
            item.funcao.toUpperCase().indexOf(this.funcao.toUpperCase()) > -1
          ) {
            return true
          }
          return false
        })
        return filter
      }

      return this.usuarios
    },
  },
  data() {
    return {
      usuario: '',
      usuariosOriginais: [],
      usuarios: [],
      funcao: '',
      loading: false,
      dataFields: {
        'Último acesso': {
          field: 'data',
          callback: (value) => {
            return value !== '' ? this.formatDate(value) : ''
          },
        },
        Nome: 'nome',
        Função: 'funcao',
        Status: {
          field: 'status',
          callback: (value) => {
            return value == 1 ? 'Ativo' : 'Inativo'
          },
        },
        'Quant. de dias do último acesso': {
          field: 'data',
          callback: (value) => {
            return value !== '' ? this.diffDays(value.split(' ')[0]) : ''
          },
        },
      },
      reds: false,
    }
  },
  created() {
    this.carregarUsuarios()
  },
  methods: {
    onChangeFuncao(event) {
      this.page = 1
      if (event.target.value == 'todos') {
        this.funcao = ''
      } else {
        this.funcao = event.target.value
      }
    },

    async carregarUsuarios() {
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/usuarios/' + this.$store.state.cod_ibge
        )
        if (response) {
          this.usuariosOriginais = response.data
          this.usuarios = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    onChangeReds(item) {
      this.reds = item.target.checked
      if (this.reds) {
        this.usuarios = this.usuariosOriginais.filter((el) => {
          return this.diffDays(el.data.split(' ')[0]) > 30
        })
      } else {
        this.usuarios = this.usuariosOriginais
      }
    },

    generatePdf() {
      let title_pdf = 'Últimas visualizações'
      let titlePdfSave = this.titlePdf('Últimas visualizações')
      let description_pdf = 'Profissionais que acessaram o sistema'
      let headers_pdf = [
        'ÚLTIMO ACESSO',
        'NOME',
        'PERFIL',
        'STATUS',
        'QUANT. DIAS DO ÚLTIMO ACESSO',
      ]
      var data_pdf = []
      for (let i = 0; i < this.displayedUsuarios.length; i++) {
        var obj = {}
        obj.data = this.formatDate(this.displayedUsuarios[i].data)
        obj.nome = this.displayedUsuarios[i].nome
        obj.funcao = this.displayedUsuarios[i].funcao
        obj.status = this.displayedUsuarios[i].status == 1 ? 'Ativo' : 'Inativo'
        obj.dias = this.diffDays(this.displayedUsuarios[i].data.split(' ')[0])
        data_pdf.push(obj)
      }
      let doc = new jsPDF(this.encryptionPdf())
      // cria a tabela
      let table = this.createTablePdf(data_pdf)

      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .then((base64data) => {
          // Header
          let verticalPosition = this.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          // Data atual
          let data = new Date()
          let dia = String(data.getDate()).padStart(2, '0')
          let mes = String(data.getMonth() + 1).padStart(2, '0')
          let ano = data.getFullYear()
          let dataAtual = dia + '/' + mes + '/' + ano
          doc.setFontSize(12)
          doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

          verticalPosition += 6

          doc.autoTable({
            head: [headers_pdf],
            body: table,
            headStyles: {
              fillColor: '#ccc',
              fontSize: 6,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              halign: 'center',
              fontSize: 6,
            },
            theme: 'striped',
            startY: verticalPosition,
            showHead: 'firstPage',
            willDrawCell: function (data) {
              let dias = data.row.raw[4]
              if (dias > 30) {
                doc.setTextColor(194, 10, 16) // vermelho
              }

              if (data.row.section === 'head') {
                doc.setTextColor(0, 0, 0)
              }
            },
          })

          this.footerPdf(doc, doc.autoTable.previous.finalY)

          doc.save(titlePdfSave + '.pdf')

          vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style></style>
